export interface AdditionalProduct {
  additionalProductId: number;
  additionalProductCode?: string;
  additionalProductDesc: string;
}
